import Tier from "../../domain/Tier.entity";

class TiersResponse {
  constructor(response = {}) {
    this.tiers = response.data.items.map(tier => new Tier(tier));
  }
}

export default TiersResponse;
